import React from 'react';

const Progress = ({ currentStep, setCurrentStep, isStepEnabled }) => {
  return (
    <div className="space-y-8">
      <div className="flex items-center justify-center mb-12">
        <div className="flex items-center space-x-4">
          {[1, 2, 3].map((step) => (
            <React.Fragment key={step}>
              <div
                className={`step-indicator w-12 h-12 rounded-full flex items-center justify-center text-white font-bold ${
                  currentStep === step
                    ? 'active'
                    : currentStep > step
                    ? 'completed'
                    : isStepEnabled(step)
                    ? 'bg-gray-600 cursor-pointer'
                    : 'bg-gray-400 cursor-not-allowed'
                }`}
                onClick={() => isStepEnabled(step) && setCurrentStep(step)}
                style={{ cursor: isStepEnabled(step) ? 'pointer' : 'not-allowed' }}
                aria-label={`Step ${step}`}
              >
                {currentStep > step ? '✓' : step}
              </div>
              {step < 3 && (
                <div
                  className={`w-16 h-1 ${currentStep > step ? 'bg-blue-700' : 'bg-gray-600'}`}
                ></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="flex justify-between text-center mb-12 max-w-2xl mx-auto">
        <div className="flex-1">
          <div
            className={`text-sm font-semibold ${currentStep >= 3 ? 'text-white' : 'text-gray-400'}`}
          >
            Hasil Coverage
          </div>
        </div>
      </div>
    </div>
  );
};

export default Progress;